import {AxiosResponse} from 'axios';
import {API, Endpoints} from '@/repositories/beneva-api/api';
import {DetailedInvestorAccount, InvestorAccount, Investor} from '@/types/client-info';

export type SearchInvestorsInvalidSearchTermErrorResponse = {
  errorKey: 'invalid_search_term';
  investorIdLength: number;
  accountNoLength: number;
};

export function searchInvestors(searchTerm: string, dealerCode: string, repCode: string) {
  return API.post<Investor[]>(Endpoints.investors.search, {searchTerm, dealerCode, repCode});
}

export function getInvestorById(investorId: string) {
  return API.get<Investor>(Endpoints.investors.single, {params: {investorId}});
}

export function getInvestorAccount(
  investorId: string,
  accountId: string,
  includeDetails: true,
): Promise<AxiosResponse<DetailedInvestorAccount>>;
export function getInvestorAccount(
  investorId: string,
  accountId: string,
  includeDetails?: false,
): Promise<AxiosResponse<InvestorAccount>>;
export function getInvestorAccount(investorId: string, accountId: string, includeDetails = false) {
  return API.get<InvestorAccount | DetailedInvestorAccount>(Endpoints.investors.accounts.single, {
    params: {investorId, accountId, includeDetails},
  });
}
